import React from "react";
import PropTypes from "prop-types";

export const SectionItemComponent = (props) => (
  <fieldset>
    <div className="label-right">
      {props.itemKey && (
        <span
          style={{
            height: "fit-content",
            ...(props.wrapped ? { whiteSpace: "normal" } : {}),
          }}
        >
          {props.itemKey}
        </span>
      )}
      <div
        style={{
          height: "fit-content",
          width: props.itemKey ? "calc(100% - 192px)" : "100%",
        }}
      >
        <span>{props.children}</span>
      </div>
    </div>
  </fieldset>
);

SectionItemComponent.propTypes = {
  children: PropTypes.any,
  itemKey: PropTypes.string,
  wrapped: PropTypes.bool,
};

export default SectionItemComponent;
